import { render, staticRenderFns } from "./Todos-Boletos.vue?vue&type=template&id=1dfccbce&scoped=true"
import script from "./Todos-Boletos.vue?vue&type=script&lang=js"
export * from "./Todos-Boletos.vue?vue&type=script&lang=js"
import style0 from "./Todos-Boletos.vue?vue&type=style&index=0&id=1dfccbce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfccbce",
  null
  
)

export default component.exports